
import { Grid2, IconButton, Typography,Divider,List, ListItem} from '@mui/material';

import keelLogo from './assest/images/Keel.png'
import React, { useRef } from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';





const Payslip = ({values})=>{
 
  const payslipRef = useRef(); // Reference to the payslip component
    
 
  

  // Function to handle PDF download
  const downloadPDF = async () => {
    const element = payslipRef.current;
    const downloadButton = document.getElementById('downloadButton');
    if (downloadButton) downloadButton.style.display = 'none';
  
    // Capture the HTML element as a canvas
    const canvas = await html2canvas(element, {
      scale: 2, // Improve quality by increasing the scale of the canvas
    });
    const imageData = canvas.toDataURL('image/png');
  
    const pdf = new jsPDF('p', 'pt', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
  
  
  
    pdf.addImage(imageData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  
    // Download the PDF
    pdf.save('payslip.pdf');
      // Show the button again after PDF is generated
      
  if (downloadButton) downloadButton.style.display = 'inline-block';
  };
  

    const staticKeys = ["Employee Pay Summary", "EMPLOYEE NAME", "DESIGNATION",
         "DATE OF JOINING", "PAY DATE","PAY PERIOD ","PAN NUMBER","PF A/C NUMBER","UAN NUMBER","ESI NUMBER "];

     const Earnings = ["BASIC PAY","HOUSE RENT ALLOWANCE","SPECIAL ALLOWANCE","LTA ALLOWANCE","..","Gross Earnings"]   
     const Deduction =["PF AMOUNT","ESIC Amount","PROFESSIONAL TAX","INCOME TAX","GRATUITY","GROSS DEDUCTIONS"]  
      
    return (
      <Grid2  container  spacing={2} size={12}  sx={{ margin: '20px', padding: { xs: '10px', md: '30px' } }} ref={payslipRef}>
        <Grid2 container size={12} xs={12} md={12}>
           <Grid2 size={6} display={'flex'} flexDirection={'column'} xs={6}>
            
            <header style={{fontSize:"30px"}}> KEEL INFO SOLUTION PVT LTD </header>
            <span>CHENNAI, </span>
            <span>TAMILNADU 600126 </span>
           
           
           </Grid2>

           <Grid2 item xs={
               {width:"50%",display:"flex",justifyContent:"flex-end"}
           } md={3} sx={{width:{lg:"30%"}}} display={'flex'} justifyContent={'flex-end'}>
           <img src={keelLogo} alt="Keel" />
           </Grid2>
            
           <Grid2 size={12} xs={12} md ={12}>
            <Divider sx={{ height: 6, backgroundColor: 'blue', marginY: 2 }}  />
          </Grid2>
        </Grid2>
        <Grid2 container size={6} xs={6} md={6}>
         

        <h2> Payslip for the month of June 2024 </h2> 
          <List>
               {staticKeys.map((key)=>(
               <ListItem 
               key={key} 
               sx={{ 
                 display: 'grid', 
                 gridTemplateColumns: '250px auto', // Fixed width for the key column
                 gap: 1,
                 alignItems: 'center'
               }}
             >
               <Typography variant="subtitle1" fontSize={'20px'} padding={'10px'}>
                 {key}:
               </Typography>
               <Typography variant="body1" padding={'10px'}>
                 {"300000"}
               </Typography>
             </ListItem>

               ))}

          </List>
        </Grid2>
        
        

<Grid2 item xs={12} md={6} sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          border: "2px solid black",
          padding: '10px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '80%' // Adjust the width to fit the layout
        }}>
          <Typography variant="h6">Employee Net Pay</Typography>
          <Typography>Paid Days: 00.00 | LOP Days: 0.00</Typography>
        </div>
      </Grid2>

        <Grid2 size={12}>
            <Divider sx={{ height: 6, backgroundColor: 'blue', marginY: 2 }}  />
          </Grid2>
         <Grid2 item  padding={'10px'} xs={12} md={12} lg={6} xl ={6}sx={{display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: { lg: '50%' }
        }}>
           
         
             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                            <th style={{ border: '1px solid black', padding: '5px' }}>
                             Earnings
                            </th>
                            <th style={{ border: '1px solid black', padding: '10px' }}>
                                 Actuals
                            </th>
                            <th style={{ border: '1px solid black', padding: '10px' }}>
                                 Amount
                            </th>
                            <th style={{ border: '1px solid black', padding: '10px' }}>
                                YTD 
                            </th>
                        </tr>
                      </thead>
                      <tbody>
                         {Earnings.map((earning,index)=>(
                         <tr key={index}>
                            <td style={{ border: '1px solid black', padding: '5px' }}>{earning}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>1200</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>1450</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>1678</td>
                         </tr>

                         ))}

                      </tbody>

             </table>


         </Grid2>

         <Grid2 item  padding={'10px'} xs={12} xl={6}md={12} lg={6}sx={{display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: { lg: '40%' }
    }}
        
        >
            
         <table style={{ width: '100%', borderCollapse: 'collapse'}}>
                      <thead>
                        <tr>
                            <th style={{ border: '1px solid black', padding: '5px' }}>
                             Deduction
                            </th>
                        
                            <th style={{ border: '1px solid black', padding: '10px' }}>
                                 Amount
                            </th>
                            <th style={{ border: '1px solid black', padding: '10px' }}>
                                YTD 
                            </th>
                        </tr>
                      </thead>
                      <tbody>
                         {Deduction.map((earning,index)=>(
                         <tr key={index}>
                            <td style={{ border: '1px solid black', padding: '5px' }}>{earning}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>56778</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>45667</td>
                         
                         </tr>

                         ))}

                      </tbody>

             </table>

            </Grid2>
             <div style={{width:"100%",height:"60px", backgroundColor:"grey",color:"white", margin:"10px", padding:'10px'}} >
              Total Net Payable
             </div>
            <Grid2 size={12}>
            <Divider sx={{ height: 6, backgroundColor: 'blue', marginY: 2 }}  />
          </Grid2>
          

          {/* Button to download the PDF */}
      <button   id="downloadButton"  onClick={downloadPDF} style={{ margin: '20px', padding: '10px', backgroundColor: '#007BFF', color: '#fff', border: 'none', borderRadius: '5px' }}>
        Download as PDF
      </button>

      </Grid2>
      
    )
   

}
export default Payslip